const lang = document.documentElement.lang;

const tr = {
  'pt-BR': {
    modal_error_attention: 'Atenção!',
    modal_error_fields: 'Preencha os campos corretamente!',
    modal_error_pass: 'Preencha uma senha válida!',
    modal_error_captcha: 'Você deve marcar o captcha para continuar!',
    modal_error_terms: 'Você deve aceitar os termos para continuar!',
    modal_error_invite: 'Erro ao enviar convite! Tente novamente mais tarde.',
    modal_error_request: 'Erro ao enviar Solicitação!',
    modal_error_hours: 'Preencha horas e minutos corretamente',
    modal_error_minutes: 'Valor inválido para minutos, preencha um valor entre 00 e 59',
    modal_success_thanks: 'Obrigado!',
    modal_success_invite: 'Convite enviado com sucesso!',
    modal_success_invitemsg: 'O usuário deverá realizar um cadastro na plataforma para contabilizar a pontuação da sua equipe.',
    modal_delete_register: 'Excluir registro?',
    modal_delete_register_text: 'Tem certeza que deseja remover este registro?',
    modal_confirm_delete_register: 'Sim, excluir registro!',
    modal_cancel_delete_register: 'Não excluir',
    modal_warning_soon: 'Em breve!',
    modal_check_activity: 'Marque pelo menos uma atividade',
    modal_donations_quantity: 'Informe a quantidade e descrição das doações',
    modal_action_done: 'Ação concluída!',
    text_invite_sent: 'Convite enviado',
    text_no_images_added: 'Não foram adicionadas imagens nessa ação.',
    text_no_materials_added: 'Não foram adicionados materiais nessa ação.',
    title_images_gallery: 'Galeria de imagens',
    title_aditional_materials: 'Materiais adicionais',
    passwords_different: 'Senhas diferentes.',
    password_min_length: 'A senha precisa ter o mínimo de 8 caracteres.',
    password_rules: 'A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais.',
    select_unities_placeholder: 'Primeiro selecione a empresa',
    calendar: {
      format: 'DD/MM/YYYY',
      cancelLabel: 'Limpar',
      applyLabel: 'Aplicar',
      customRangeLabel: 'Custom',
      daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    },
  },
  en: {
    modal_error_attention: 'Attention!',
    modal_error_fields: 'Enter the fields correctly!',
    modal_error_pass: 'Preencha uma senha valid!',
    modal_error_captcha: 'You must mark the captcha to continue!',
    modal_error_terms: 'You must accept the terms to continue!',
    modal_error_invite: 'Error sending invitation! Try again later.',
    modal_error_request: 'Error sending request!',
    modal_error_hours: 'Fill hours and minutes correctly',
    modal_error_minutes: 'Invalid value for minutes, fill in a value between 00 and 59',
    modal_success_thanks: 'Thanks!',
    modal_success_invite: 'Invitation sent successfully!',
    modal_success_invitemsg: "The user must register on the platform to count your team's score.",
    modal_delete_register: 'Delete record?',
    modal_delete_register_text: 'Are you sure you want to remove this record?',
    modal_confirm_delete_register: 'Yes, delete record!',
    modal_cancel_delete_register: 'Do not delete',
    modal_warning_soon: 'Coming soon!',
    modal_check_activity: 'Mark at least one activity',
    modal_donations_quantity: 'Enter the amount and description of donations',
    modal_action_done: 'Action completed!',
    text_invite_sent: 'Invitation sent',
    text_no_images_added: 'No images were added to this action.',
    text_no_materials_added: 'No materials were added in this action.',
    title_images_gallery: 'Image gallery',
    title_aditional_materials: 'Additional materials',
    passwords_different: 'Passwords are different',
    password_min_length: 'The password must be a minimum of 8 characters.',
    password_rules: 'The password must contain uppercase letters, lowercase letters, numbers and special characters.',
    select_unities_placeholder: 'First select the company',
    calendar: {
      format: 'MM/DD/YYYY',
      cancelLabel: 'Clean',
      applyLabel: 'Apply',
      customRangeLabel: 'Custom',
      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
  },
  es: {
    modal_error_attention: '¡Atención!',
    modal_error_fields: '¡Preencha los campos correctamente!',
    modal_error_pass: '¡Preencha uma senha válida!',
    modal_error_captcha: '¡Debes verificar el captcha para continuar!',
    modal_error_terms: '¡Você deve aceitar os termos para continuar!',
    modal_error_invite: '¡Error al enviar la invitación! Vuelve a intentarlo más tarde.',
    modal_error_request: '¡Error al enviar la solicitud!',
    modal_error_hours: 'Completar horas y minutos correctamente',
    modal_error_minutes: 'Valor no válido para informar minutos. Complete un valor entre 00 y 59',
    modal_success_thanks: '¡Gracias!',
    modal_success_invite: '¡Invitación enviada exitosamente!',
    modal_success_invitemsg: 'El usuario deberá registrarse en la plataforma para registrar la puntuación de su equipo.',
    modal_delete_register: '¿Eliminar el registro?',
    modal_delete_register_text: '¿Estás seguro de que deseas eliminar este registro?',
    modal_confirm_delete_register: '¡Sí, eliminar registro!',
    modal_cancel_delete_register: 'No eliminar',
    modal_warning_soon: '¡Muy pronto!',
    modal_check_activity: 'Marca al menos una actividad',
    modal_donations_quantity: 'Ingrese el monto y descripción de las donaciones',
    modal_action_done: '¡Acción completada!',
    text_invite_sent: '¡Invitación enviada!',
    text_no_images_added: 'No se añadieron imágenes en esta acción.',
    text_no_materials_added: 'No se añadieron materiales en esta acción.',
    title_images_gallery: 'Galería de imágenes',
    title_aditional_materials: 'Materiales adicionales',
    passwords_different: 'Diferentes contraseñas.',
    password_min_length: 'La contraseña debe tener un mínimo de 8 caracteres.',
    password_rules: 'La contraseña debe contener letras mayúsculas, minúsculas, números y caracteres especiales.',
    select_unities_placeholder: 'Primero selecciona una empresa',
    calendar: {
      format: 'DD/MM/YYYY',
      cancelLabel: 'Limpiar',
      applyLabel: 'Aplicar',
      customRangeLabel: 'Personalizado',
      daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    },
  },
};

export { tr, lang };
